module.exports = "/_next/static/images/icon-tree-5647b4851ea427cfe877dac08d94cd6b.svg";